module.exports = __webpack_public_path__ + "static/media/PP1-5K.ea4613e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper1/PP1-5K.png
// module id = 240
// module chunks = 0